import { FC, useState } from 'react';
// import cs from 'classnames';
import styles from './index.module.less';
import V2Title from '@/common/components/Feedback/V2Title';
import { PlusCircleOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import IconFont from '@/common/components/IconFont';
import { useMethods } from '@lhb/hook';

/**
 * @Description 关联机会点后的显示
 */
const CorrelatedChancePoint: FC<{
  chancepointAlias,
  relativeChancePoints,
  createChancePoint,
  relativeChancePoint,
  setPointId,
  setDetailVisible,
  /** 是否展示机会点操作 */
  ableToChangepoint: boolean,
  /** 是否禁用（分享时禁用操作） */
  disabled?: boolean;
}> = ({
  chancepointAlias,
  relativeChancePoints,
  createChancePoint,
  relativeChancePoint,
  setPointId,
  setDetailVisible,
  ableToChangepoint = true, // 是否展示机会点操作
  disabled,
}) => {
  const [isExpanded, setExpanded] = useState(false); // 是否设置展开

  const methods = useMethods({

    showDetail(id) {
      if (disabled) {
        return;
      }
      setPointId(id);
      setDetailVisible(true);
    },

  });

  return (
    <div className={styles.correlatedChancePoint}>
      <V2Title type='H2' text='记录点位信息' extra={
        !disabled && ableToChangepoint ? <Popover overlayClassName={styles.popoverWrap} placement='bottomRight' title={null} content={(
          <div className={styles.continueAddPointType}>
            <div className={styles.typeItem} onClick={createChancePoint}>新建{chancepointAlias}</div>
            <div className={styles.typeItem} onClick={relativeChancePoint}>关联{chancepointAlias}</div>
          </div>
        )} trigger='hover'>
          <div className={styles.continueAddPoint}>
            <PlusCircleOutlined />
            <span>继续添加</span>
          </div>
        </Popover> : <></>}
      />
      <div className={styles.chancePointList} >
        { relativeChancePoints.map((item: any, index: number) => (
          <div key={index} style={{ display: (!isExpanded && index >= 2) ? 'none' : 'block' }}>
            <div className={styles.chancePointItem} onClick={() => methods.showDetail(item.id)}><div className={styles.chancePointItemName}>{item.name}</div>
              <div className={styles.chancePointItemStatus}>{item.statusName}</div>
              {!disabled && <div className={styles.chancePointItemIcon}>
                <IconFont iconHref='iconic_zhuanjiao_seven' />
              </div>}
            </div>
          </div>
        )) }
      </div>
      { relativeChancePoints?.length > 2 && <div className='mt-8'>
        <span className={styles.moreBtn} onClick={() => setExpanded(!isExpanded)}>{ isExpanded ? '收起' : '展开' }更多</span>
      </div>}
    </div>
  );
};

export default CorrelatedChancePoint;
